import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import type { Dayjs } from 'dayjs';

/**
 * Historique des statuts d'une période (GET /period_status_histories) : qui / quand (createdBy / createdAt).
 * La ligne Clôturée d'une période donne sa date de clôture. Filtres : period (IRI, ou liste d'IRI), periodStatus.
 */
export default class PeriodStatusHistoryModel extends AbstractApiModel {
  protected _path = '/period_status_histories/{?id}';

  declare _tsFilters: { period?: string | string[]; periodStatus?: id };

  @doc.date declare createdAt: Dayjs;
  @doc.string declare createdBy: string;

  /** period arrive imbriquée ({@id, month…}) ; IRI seule par prudence */
  get periodId(): number {
    const period = this.get<unknown, unknown>('period', null);
    const iri = typeof period === 'string' ? period : ((period as { '@id'?: string } | null)?.['@id'] ?? '');
    return Number(iri.split('/').pop()) || 0;
  }
}
